import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LoginInfo, Status, GetUserInfo } from '../../services/apiTypes';
import { postLogin as postLoginAPI, PutOrPostResponse } from './api';
import { getMe as getMeAPI } from './api';
import { postLogout as postLogoutAPI } from './api';
import { isGetUserInfo } from '../../_utils/typeGuardUtils';

interface UserState {
  status: Status;
  userData: GetUserInfo;
}

const initialUserData: GetUserInfo = {
  userId: '',
  name: '',
  roleId: 0,
  companyKey: '',
  language: '',
  isLocked: false,
  dateFormat: 0,
  partsListDisplayPattern: 0,
};

const initialState: UserState = {
  status: 'idle',
  userData: initialUserData,
};

export const postLogin = createAsyncThunk(
  'auth/login/postLogin',
  async (params: LoginInfo, { rejectWithValue }) => {
    try {
      return await postLoginAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getMe = createAsyncThunk(
  'auth/me/getMe',
  async (_, { rejectWithValue }) => {
    try {
      return await getMeAPI();
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const postLogout = createAsyncThunk<PutOrPostResponse>(
  'auth/logout/postLogout',
  async (_, { rejectWithValue }) => {
    try {
      return await postLogoutAPI();
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postLogin.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postLogin.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetUserInfo(action.payload)) {
          state.userData = action.payload;
        }
      })
      .addCase(postLogin.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getMe.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getMe.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetUserInfo(action.payload)) {
          state.userData = action.payload;
        }
      })
      .addCase(getMe.rejected, (state) => {
        state.status = 'failed';
        state.userData = initialUserData;
      })
      .addCase(postLogout.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postLogout.fulfilled, (state) => {
        state.status = 'succeeded';
        state.userData = initialUserData;
      })
      .addCase(postLogout.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default userSlice.reducer;
